import axios from 'axios';
import { getUserData } from './storageService';

const BASE_URL = process.env.REACT_APP_API_URL || 'https://backend-c-0mxm.onrender.com';
const API_URL = BASE_URL.replace(/\/api$/, '');

const getAuthHeaders = () => {
  const user = getUserData();
  return {
    Authorization: `Bearer ${user?.userId || ''}`
  };
};

const api = axios.create({
  baseURL: `${API_URL}/api/timesheet`,
});

api.interceptors.request.use((config) => {
  config.headers = { ...config.headers, ...getAuthHeaders() };
  return config;
});

const timesheetService = {
  // Get entries
  getEntries: async (params = {}) => {
    const response = await api.get('/', { params });
    return response.data;
  },

  // Get summary
  getSummary: async (month, year) => {
    const response = await api.get('/summary', { params: { month, year } });
    return response.data;
  },

  // Get history with filter or specific month/year
  getHistory: async (filter = 'month', month = null, year = null) => {
    const params = { filter };
    if (month && year) {
      params.month = month;
      params.year = year;
    }
    const response = await api.get('/history', { params });
    return response.data;
  },

  // Create entry
  create: async (data) => {
    const response = await api.post('/', data);
    return response.data;
  },

  // Update entry
  update: async (id, data) => {
    const response = await api.put(`/${id}`, data);
    return response.data;
  },

  // Delete entry
  delete: async (id) => {
    const response = await api.delete(`/${id}`);
    return response.data;
  },

  // Format time (minutes to "Xh Yp")
  formatTime: (totalMinutes) => {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    if (hours === 0) return `${minutes} phút`;
    if (minutes === 0) return `${hours} giờ`;
    return `${hours}h ${minutes}p`;
  },

  // Format currency
  formatCurrency: (amount) => {
    return new Intl.NumberFormat('vi-VN', {
      style: 'currency',
      currency: 'VND',
    }).format(amount);
  },

  // Work type labels
  workTypes: {
    quay: 'Quay phim',
    dung: 'Dựng video',
    quay_dung: 'Quay + Dựng',
    khac: 'Khác',
  },
};

export default timesheetService;
